import { render, staticRenderFns } from "./PosturasListViewById.vue?vue&type=template&id=e2f2ba3c&scoped=true"
import script from "./PosturasListViewById.vue?vue&type=script&lang=js"
export * from "./PosturasListViewById.vue?vue&type=script&lang=js"
import style0 from "./PosturasListViewById.vue?vue&type=style&index=0&id=e2f2ba3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f2ba3c",
  null
  
)

export default component.exports